import React from 'react';

const Wizard = ({ step }) => {
    return (
        <div className="row justify-content-center pt-0 p-4" id="wizardRow">
            <div className="col-md-12 text-center">
                <h2 className="mb-45">{step === 1 ? 'Party Selection' : step === 2 ? 'Party Guest' : 'Party Orders'}</h2>
                <div className="wizard-form py-4 my-2 mt-3">
                    <ul id="progressBar" className="progressbar px-lg-5 px-0 mb-2 text-center">
                        <li className={`d-inline-block w-20 position-relative text-center progressbar-list ${step >= 1 ? 'active' : ''}`}>Step 1</li>
                        <li className={`d-inline-block w-20 position-relative text-center progressbar-list ${step >= 2 ? 'active' : ''}`}>Step 2</li>
                        <li className={`d-inline-block w-20 position-relative text-center progressbar-list ${step >= 3 ? 'active' : ''}`}>Step 3</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Wizard;
